import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-down",
  "use": "icon-arrow-down-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-arrow-down\">\n<path d=\"M109.776,104.9l48.918-48.918c5.401-5.401,14.159-5.401,19.56,0l0,0c5.401,5.401,5.401,14.159,0,19.56l-68.478,68.478\n\tc-5.399,5.399-14.152,5.399-19.551,0L21.747,75.542c-5.401-5.401-5.401-14.159,0-19.56l0,0c5.401-5.401,14.159-5.401,19.56,0\n\tL90.224,104.9C95.623,110.299,104.377,110.299,109.776,104.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrow-down.svg
// module id = Peom
// module chunks = 3